/* drl-legal-doc — tartalomjegyzék a jogi oldalak h2 címsoraiból.
   Nulla függőség. Ha nincs h2, a jegyzék rejtve marad. */
(() => {
  const root = document.querySelector('[data-drl-legal]');
  if (!root) return;
  const nav = root.querySelector('[data-drl-legal-toc]');
  const body = root.querySelector('[data-drl-legal-body]');
  if (!body) return;

  // ── AZ ÖRÖKÖLT MARADVÁNYOK ─────────────────────────────────────────
  // A régi oldalszerkesztő kimenete: saját h1 (a fejléc már kiírta a címet),
  // a címet megismétlő bekezdés, tömegével üres bekezdés, és egy halvány
  // logókép a szöveg tetején. A VÉGLEGES javítás a bolt tartalmában van;
  // ez a réteg addig is rendet tesz, és minden örökölt oldalra hat.
  if (root.dataset.stripLegacy === 'true') {
    const title = (root.dataset.pageTitle || '').trim().toLowerCase();
    body.querySelector('h1')?.remove();
    // Üres címsorok: az örökölt adatvédelmi szabályzat egy <h2></h2>-t visz,
    // amiből üres jegyzék-tétel lenne.
    body.querySelectorAll('h2, h3, h4, h5, h6').forEach((h) => {
      if (!h.textContent.replace(/\u00a0/g, ' ').trim()) h.remove();
    });
    body.querySelectorAll('p').forEach((p) => {
      const t = p.textContent.replace(/\u00a0/g, ' ').trim();
      if (!t && !p.querySelector('img')) p.remove();
      else if (title && t.toLowerCase() === title) p.remove();
    });
    if (root.dataset.stripImages === 'true') {
      body.querySelectorAll('img').forEach((img) => (img.closest('p') || img).remove());
    }
    // Szakaszcím-térkép: ahol a szöveg nem jelöli a fejezeteket, a címeket a
    // téma adja. A jogi szöveg egyetlen betűje sem változik — a cím fölé kerül,
    // vagy a puszta sorszámot tartalmazó bekezdés helyére.
    //   „1 | Megrendelés"          a szakasz első 1.x pontja fölé
    //   „Lehetséges fizetési | Fizetési módok"   az így KEZDŐDŐ bekezdés fölé
    (root.dataset.sectionMap || '')
      .split('\n')
      .map((line) => line.split('|'))
      .filter((pair) => pair.length === 2)
      .forEach(([key, label]) => {
        const k = key.trim();
        const title = label.trim();
        if (!k || !title) return;
        const numbered = /^\d+$/.test(k);
        const re = numbered ? new RegExp('^' + k + '\\.(\\d+\\.?)?(\\s|$)') : null;
        // A Wordből jött szövegekben a szóközök szeszélyesek („1.   A Szervező").
        const flat = (el) => el.textContent.replace(/[\s\u00a0]+/g, ' ').trim();
        const kFlat = k.replace(/\s+/g, ' ').trim().toLowerCase();
        const p = [...body.querySelectorAll('p')].find((el) => {
          const t = flat(el);
          return numbered ? re.test(t) : t.toLowerCase().startsWith(kFlat);
        });
        if (!p) return;
        const h = document.createElement('h2');
        h.textContent = numbered ? `${k}. ${title}` : title;
        // Ha a horgony maga a teljes bekezdés, a cím a HELYÉRE kerül — különben
        // ugyanaz a sor kétszer állna egymás alatt.
        const whole = numbered ? flat(p) === `${k}.` : flat(p).toLowerCase() === kFlat;
        if (whole) p.replaceWith(h);
        else p.before(h);
      });

    // Csupa nagybetűs, rövid, pont nélküli bekezdés = szakaszcím. Az örökölt
    // szövegek így jelölik a fejezeteket (ADATKEZELÉS CÉLJAI), és ebből lesz
    // a tartalomjegyzék is. Szigorú: egyetlen kisbetű is kizárja.
    body.querySelectorAll('p').forEach((p) => {
      const t = p.textContent.replace(/\u00a0/g, ' ').trim();
      // Felkiáltás vagy kettőspont: kiemelés, nem szakaszcím („FIGYELEM!").
      if (t.length < 3 || t.length > 80 || /[.!?:]$/.test(t)) return;
      if (t !== t.toUpperCase() || !/\p{L}/u.test(t)) return;
      const h = document.createElement('h2');
      h.textContent = t;
      p.replaceWith(h);
    });

    // A szerkesztő üres wrapper-divjei (gf_row, clearfix): nem látszanak, de
    // helyet foglalnak — az ÁSZF tetején ez volt a 250px-es rés.
    body.querySelectorAll('div').forEach((d) => {
      if (!d.textContent.replace(/\u00a0/g, ' ').trim() && !d.querySelector('img, iframe, a, input, video')) {
        d.remove();
      }
    });
  }

  if (!nav) return;

  const headings = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
  if (headings.length < 2) {
    root.classList.add('drl-legal--no-toc'); // :has() nélküli böngészőknek
    return; // egy szakasz nem jegyzék
  }

  const slug = (s) =>
    s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);

  const list = nav.querySelector('ol');
  const links = new Map();
  const used = new Set();

  headings.forEach((h, i) => {
    if (!h.id) {
      let id = slug(h.textContent) || `szakasz-${i + 1}`;
      while (used.has(id)) id = `${id}-${i}`;
      h.id = id;
    }
    used.add(h.id);
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    // A vezető sorszámot a jegyzék countere adja — a címsorból levágjuk,
    // különben „1. 1. Általános rendelkezések" lesz belőle.
    a.textContent = h.textContent.trim().replace(/^\d+(\.\d+)*\.?\s+/, '');
    li.appendChild(a);
    list.appendChild(li);
    links.set(h.id, a);
  });

  nav.hidden = false;

  // Gorgetes-koveto: az utolso lathato cimsor az aktualis.
  const seen = new Set();
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => (e.isIntersecting ? seen.add(e.target.id) : seen.delete(e.target.id)));
      const current = headings.find((h) => seen.has(h.id));
      links.forEach((a) => a.removeAttribute('aria-current'));
      if (current) links.get(current.id).setAttribute('aria-current', 'true');
    },
    { rootMargin: '-10% 0px -70% 0px' }
  );
  headings.forEach((h) => io.observe(h));
})();
